// @flow
import { useMutation, MutationOptions } from 'react-query';
import { createOrUpdateAffordaPortalForms } from 'services/affordaPortalForms';
import { useContext } from 'react';
import { AppContext } from 'contexts/AppContext';
import useMemoizedQueryOptions from 'hooks/affordaPortalFormState/useMemoizedQueryOptions';
import useAbortController from 'hooks/useAbortController';
import { useUserContext } from 'contexts/UserContext';
import { IS_DEVELOPMENT } from 'constants/environment';

type Payload = {
  applicationId: string,
  applicantId: string,
  householdId: string,
  welcomeAndQualify: Object,
  wagesAndIncome: Object,
  assets: Object,
};

type Props = {
  options?: MutationOptions,
};

const useCreateOrUpdateAffordaPortalFormsMutation = ({
  options,
}: Props = {}) => {
  const { organizationId, propertyId } = useContext(AppContext);
  const { portalUserId } = useUserContext();
  const abortControllerOptions = useAbortController();
  const memoizedOptions = useMemoizedQueryOptions({
    options,
    organizationId,
    propertyId,
    portalUserId,
  });

  return useMutation(async ({ id, ...payload }: Partial<Payload>) => {
    if (!Boolean(portalUserId?.length)) {
      if (IS_DEVELOPMENT) console.error('portalUserId is required.');
      return;
    }

    const finalPayload: Payload = {
      ...(id && { id }),
      portalUserId,
      ...payload,
    };

    return createOrUpdateAffordaPortalForms({
      organizationId,
      propertyId,
      portalUserId,
      payload: finalPayload,
      options: abortControllerOptions,
    });
  }, memoizedOptions);
};

export default useCreateOrUpdateAffordaPortalFormsMutation;
